<template>
  <div class="filial-menu-item" :class="{'food-card__activated': activated}">
    <!--    <div class="badge-left d-flex flex-column align-center">
      <component :is="getLeftSticker"/>
      <icon-doubling v-if="isDoubling"/>
    </div>

    <div class="badge-right d-flex flex-column align-center">
      <component :is="getRightSticker"/>
    </div>-->

    <div
      class="card-image d-flex align-center justify-center"
      @click="$emit('image-click')"
    >
      <img v-if="item.image" :src="item.image" alt="Food"/>
      <font-awesome-icon v-if="!item.image" icon="utensils"/>

      <div v-if="activated" class="food-card_label">
        Добавлено
      </div>
    </div>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          @click="emitEvents"
          class="footer"
        >
          <div class="d-flex align-center justify-space-between footer_inner">
            <div class="card-info">
              <span class="title font-weight-regular">{{ item.name }}</span>
              <span class="price font-weight-medium">{{ item.price | amountStringWithCurrency }}</span>
            </div>
            <v-btn v-if="activated" class="button-action button-action__remove" color="#ff005f" dark circle fab depressed>
              <font-awesome-icon icon="trash" />
            </v-btn>
            <v-btn v-else class="button-action" color="success" dark circle fab depressed>
              <font-awesome-icon icon="plus" />
            </v-btn>
          </div>
        </div>
      </template>
      <template v-if="activated">
        Удалить из меню филиала
      </template>
      <template v-else>
        Добавить в меню филиала
      </template>
    </v-tooltip>
  </div>
</template>

<script>
  import mixinGetFoodStickers from '@/mixins/get-food-stickers'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  // import IconDoubling from '@/components/order-processing/order-components/icons/IconDoubling'

  export default {
    name: 'FilialMenuItem',
    components: {
      // IconDoubling,
    },
    mixins: [mixinGetFoodStickers, mixinSnackbarMessage],
    emits: [
      'image-click',
      'add',
      'remove',
    ],
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
      activated: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      /* activated () {
        return this.item.isAvailableInFilials
      }, */
      hasBonus () {
        return this.item.foxCoinsAdd
      },
      isDoubling () {
        return this.item && this.item.isDoubling
      },
    },
    methods: {
      emitEvents () {
        if (!this.activated) {
          this.$emit('add', this.item.id)
        } else {
          this.$emit('remove', this.item.id)
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.filial-menu-item {
  position: relative;
  background-color: #ffffff;
  border-radius: 10px;
  //box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  box-shadow: 0 3px 6px #00000029;
  overflow: hidden;
  //padding-top: 10px;
  z-index: 0;
  font-size: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: stretch;

  .media-xl({
    font-size: 14px;
  });

  .badge-left {
    position: absolute;
    top: 15px;
    left: 8px;

    svg {
      margin-bottom: 10px;
    }

    .fox-coins {
      svg {
        margin-bottom: 0;
      }

      span {
        color: #ff9100;
        font-size: 1em;
        font-weight: bold;
      }
    }
  }

  .badge-right {
    position: absolute;
    top: 15px;
    right: 26px;

    svg {
      margin-bottom: 10px;
    }
  }

  .card-image {
    width: 100%;
    height: 182px;
    text-align: center;
    cursor: pointer;
    object-fit: contain;
    background-color: @menu-item-image-bg;

    svg {
      width: 70px;
      height: 70px;
      opacity: 0.4;
      .fill-svg(@color-primary);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

  }

  .footer {
    padding: 11px 20px 15px 16px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    flex-grow: 1;
    display: flex;
    align-items: center;

    &:hover {
      background-color: #ffddac;
    }

    &_inner {
      flex-grow: 1;
    }

    .card-info {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .title,
      .price {
        display: block;
      }

      .title {
        font-size: 1em !important;
        font-weight: 500 !important;
        line-height: 1;
        margin-bottom: 6px;
        min-height: 2em;
      }

      .price {
        font-size: 1.5em;
        line-height: 1.2;
      }
    }

    .button-action {
      margin-left: 28px;
      width: 40px;
      height: 40px;

      svg {
        width: 20px;
        height: 20px;
      }

      &__remove {
        svg {
          color: #fff;
          path {
            fill: #ffffff !important;
          }
        }
      }
    }

  }

  &.food-card__activated {
    .card-image {
      position: relative;

      img {
        opacity: 0.5;
        filter: blur(1px);
      }
      .food-card_label {
        display: flex;
        align-items: center;
        padding: 10px;
        border-radius: 10px;
        position: absolute;
        top: 50%;
        left: 50%;
        background: @color-primary;
        color: #fff;
        font-size: 14px;
        text-transform: uppercase;
        font-weight: bold;
        white-space: nowrap;
        transform: translate(-50%, -50%);
        svg {
          width: 30px;
          height: 30px;
          margin-right: 10px;
          color: #fff;
          path {
            fill: #ffffff !important;
          }
        }
      }
    }

  }
}
</style>
